<script setup lang="ts">
import { ref, computed } from 'vue';
import { Grid, GridDataStateChangeEvent, GridSortChangeEvent } from '@progress/kendo-vue-grid';
import { process } from '@progress/kendo-data-query';

const gridPageable = ref(true);
const skip = ref(0);
const sort = ref();
const group = ref();
const take = ref(10);
const columns = ref([
  { field: 'ProductID', title: 'ID', width: '50px', sortable: false, groupable: false },
  { field: 'ProductName', title: 'Product Name' },
  { field: 'UnitPrice', title: 'Unit Price', sortable: false },
  { field: 'UnitsInStock', title: 'Units In Stock' },
]);

const createRandomData = (count: number) => {
  const productNames = ['Chai', 'Chang', 'Syrup', 'Apple', 'Orange', 'Banana', 'Lemon', 'Pineapple', 'Tea', 'Milk'];
  const unitPrices = [12.5, 10.1, 5.3, 7, 22.53, 16.22, 20, 50, 100, 120];
  const units = [2, 7, 12, 25, 67, 233, 123, 53, 67, 89];

  return Array(count).fill({}).map((_, idx) => ({
    ProductID: idx + 1,
    ProductName: productNames[Math.floor(Math.random() * productNames.length)],
    UnitPrice: unitPrices[Math.floor(Math.random() * unitPrices.length)],
    UnitsInStock: units[Math.floor(Math.random() * units.length)],
  }));
};

const products = createRandomData(30);

const gridData = computed(() => process(products, { take: take.value, skip: skip.value, sort: sort.value }));

const createAppState = (dataState: { take?: number; skip?: number, sort?: any, group?: any }) => {
  if (dataState?.group) {
    group.value = dataState.group;
  }
  if (dataState?.take) {
    take.value = dataState.take;
  }
  if (dataState?.skip) {
    skip.value = dataState.skip;
  }
  if (dataState?.sort) {
    sort.value = dataState.sort;
  }
};

const dataSortChange = (event: GridSortChangeEvent): void => {
  createAppState(event);
}

const dataStateChange = (event: GridDataStateChangeEvent): void => {
  createAppState(event.data);
};

sort.value = [{ field: 'ProductName', dir: 'desc' }];
group.value = [{ field: 'ProductName' }];
</script>

<template>
  <grid
    ref="grid"
    class="tw-h-64 tw-max-w-xl"
    :data-items="gridData"
    :reorderable="true"
    :pageable="gridPageable"
    :groupable="true"
    :group="group"
    :sortable="true"
    :sort="sort!"
    :take="take"
    :skip="skip"
    :columns="columns"
    @sortchange="dataSortChange"
    @datastatechange="dataStateChange"
  >
  </grid>

</template>
